<template>
  <v-container fluid class="reimbursement-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="8" class="d-flex justify-space-between justify-md-start">
              <v-btn color="success" class="button-shadow mr-3" @click="findReimbursementDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="selectedOrders"
              loading-text="Loading... Please wait"
              class="reimbursements-table"
              sort-by="reimbursementnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_reimbursements"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="emailDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Send Email for {{ 'Reimbursement #' + emailItem.reimbursementnum }} ?
                    </v-card-title>

                    <v-card-text>
                      This action will send email to all employees. After emails are sent, this action cannot be undone. 
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="emailDialog = false">Cancel</v-btn>
                      <v-btn color="success" class="button-shadow" @click="emailReimbursement(emailItem)">Send</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                </div>
              </template>
              <template v-slot:item.transactions="{ item }">
                <p class="two-line">{{ item.transactions!==undefined ? item.transactions.map(trans=>{return '#' + trans.claimnum + ' ' + trans.transname}).join(", ") : '' }} </p>
              </template>
              <template v-slot:item.reimbursementnum="{ item }">
                <p class="two-line">{{ item.reimbursementtype  }} {{ item.reimbursementnum  }}</p>
                <p v-if="item.reimbursementdate!=undefined" class="two-line">{{ new Date(item.reimbursementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.accountid="{ item }">
                {{ accounts.length>0 && accounts.find(account=>account._id == item.accountid)!=null ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
              </template>
              <template v-slot:item.reimbursementtotal="{ item }">
                {{ item.reimbursementtotal.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.reimbursementstatus="{ item }">
                <v-chip
                  v-if="item.reimbursementstatus!=undefined"
                  :color="
                  item.reimbursementstatus=='New' ? 'primaryConst white--text' : 
                  item.reimbursementstatus=='Pending' ? 'warning white--text' : 
                  item.reimbursementstatus=='Complete' ? 'successConst white--text' : 
                  item.paymentstatus=='Rejected' ? 'redConst white--text' : 
                  'secondaryConst white--text'" small>
                  {{ item.reimbursementstatus }}
                </v-chip>
              </template>
              <template v-slot:item.approval="{ item }">
                <div v-if="item.approval!=null && item.approval.approverid!=null">
                  <p class="two-line" style="margin-left: 5px;">
                    <v-avatar v-if="item.approval.approvalimage!=null" size="40">
                      <img v-bind:src="item.approval.approvalimage" alt="">
                    </v-avatar>
                  </p>
                <p class="two-line"><span style="margin-left:5px">{{ item.approval.approvalname }} </span></p>
                </div>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                  <v-btn icon color="primary" @click="viewItem(item)">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn v-if="item.reimbursementstatus=='New'" icon color="primary" @click="updateReimbursementPendingDialog(item)">
                    <v-icon>mdi-account-edit-outline</v-icon>
                  </v-btn>
                  <v-btn v-if="item.reimbursementstatus=='New'" icon color="primary" @click="editItem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="printItem(item)">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-btn v-if="item.reimbursementstatus=='Complete'" icon color="primary" @click="showEmailDialog(item)">
                    <v-icon>mdi-email-send-outline</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findReimbursementDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Reimbursements</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="accounts.filter(x=>x.accountstatus=='Active').map(x => {
                            return {text: x.accountname, value: x._id};
                          })"
                  v-model="query.accountid"
                  label="Account"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findReimbursementDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReimbursements"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReimbursements"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="isApproveSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_send.reimbursementtype }} {{ approve_send.reimbursementnum }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveSend=false; approve_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_send.confirm!=='Send'"
                @click="updateReimbursementPending"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ReimbursementList',
  data() {
    return {
      config,
      findReimbursementDialog: false,
      emailDialog: false,
      isApproveSend: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      query: {},
      approve_send: {},
      emailItem: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Reimbursement', value: 'reimbursementnum', sortable: false, width: '10%' },
        { text: 'Claims', value: 'transactions' },
        { text: 'Account', value: 'accountid', width: '15%' },
        { text: 'Amount', value: 'reimbursementtotal', width: '10%' },
        { text: 'Approval', value: 'approval', width: '12%' },
        { text: 'Status', value: 'reimbursementstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '15%' },
      ],
      data_reimbursements: [],
      selectedOrders: [],
    }
  },
  computed: {
    ...mapState('Reimbursement', ['reimbursements', 'isReceiving', 'isDeleting', 'idToDelete', 'reimbursementsMessage', 'isUpdating']),
    ...mapState('Account', ['accounts']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Reimbursement', ["emailReimbursementRequest", "getReimbursementsRequest", "getReimbursementQueryRequest", "deleteReimbursementRequest", "updateReimbursementPendingRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    editItem(item) {
      this.$router.push({ name: 'ReimbursementEdit', params: item })
    },
    async emailReimbursement(item) {
      await this.emailReimbursementRequest({_id: item._id});
      this.emailDialog = false;
    },
    showEmailDialog(item) {
      this.emailDialog = true;
      this.emailItem = {
        _id: item._id,
        reimbursementnum: item.reimbursementnum,      
      }
    },
    printItem(item) {
      this.$router.push({ name: 'ReimbursementPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'ReimbursementView', params: item })
    },
    async findReimbursements(){
      this.findReimbursementDialog = false;
      if(this.query=={}){
        await this.getReimbursementsRequest();
        this.data_reimbursements = Object.assign([], this.reimbursements);
        this.data_reimbursements.push({reimbursementtotal: this.reimbursements.reduce(function (last, json) {return last + json.reimbursementtotal;}, 0) });
      }
      else{
        let result = await this.getReimbursementQueryRequest(this.query);
        this.data_reimbursements = Object.assign([], result);
        this.data_reimbursements.push({reimbursementtotal: result.reduce(function (last, json) {return last + json.reimbursementtotal;}, 0) });
      }
    },
    async resetReimbursements(){
      this.query = {};
    },
    updateReimbursementPendingDialog(item) {
      this.isApproveSend = true;
      this.approve_send = {
        _id: item._id,
        reimbursementnum: item.reimbursementnum,
        reimbursementtype: item.reimbursementtype,
      };
    },
    async updateReimbursementPending() {
      this.isApproveSend = false;
      let result = await this.updateReimbursementPendingRequest(this.approve_send);
      let index = this.data_reimbursements.findIndex((x) => x._id == result._id);
      this.data_reimbursements.splice(index, 1, result);
      this.approve_send = {};
    },
  },
  async created () {
    await this.getReimbursementsRequest();
    this.data_reimbursements = Object.assign([], this.reimbursements);
    this.data_reimbursements.push({reimbursementtotal: this.reimbursements.reduce(function (last, json) {return last + json.reimbursementtotal;}, 0) });
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
